import { render, staticRenderFns } from "./NotamCard.vue?vue&type=template&id=416dc140&scoped=true"
import script from "./NotamCard.vue?vue&type=script&lang=js"
export * from "./NotamCard.vue?vue&type=script&lang=js"
import style0 from "./NotamCard.vue?vue&type=style&index=0&id=416dc140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416dc140",
  null
  
)

export default component.exports